import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { Comment } from "../../models/comment";
import { mockedWorkordersComments } from "./comment-api.mock-constants.ts";
import { CommentApi } from "./comment-api.models";

@Injectable()
export class MockCommentApiService extends CommentApi {
  constructor() {
    super();
  }

  public getPredefinedComments(): Observable<Comment[]> {
    return of(mockedWorkordersComments);
  }
}
